<template>
  <v-card flat tile class="filter">
    <v-row no-gutters align="center" class="px-3 s-header">
      <v-col class="font-weight-bold text-h6">
        {{ name }}
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <div class="s-filter-ogs">
      <v-expansion-panels flat accordion tile>
        <v-expansion-panel v-for="og in ogs" :key="og.refId">
          <v-expansion-panel-header class="px-3">
            <span class="font-weight-bold">{{ og.name }}</span>
            <v-spacer></v-spacer>
            <div class="text-right">
              <v-dialog
                v-if="og.dynamic"
                max-width="500px"
                v-model="openStockUniverse"
                scrollable
                persistent
              >
                <template v-slot:activator="{ on, attrs }">
                  <a v-bind="attrs" v-on="on" class="caption"> Create </a>
                </template>
                <StockUniverse
                  :ogId="og.refId"
                  :open.sync="openStockUniverse"
                  @appendOgs="appendOgs"
                />
              </v-dialog>
              <a
                v-if="og.optionType === 'Checkbox' && og.refId != 'STOCK_UNIVERSE'"
                class="px-1 caption"
                @click.stop.prevent="selectAll(og)"
                >Select All</a
              >
              <a
                v-if="og.showClearOption"
                class="px-1 caption"
                @click.stop.prevent="clear(og)"
                >
                  <span v-if="og.optionType === 'Checkbox'">Clear</span>
                  <span v-else>Reset</span>
                </a
              >
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pb-3 px-2">
            <component
              :is="og.optionType"
              :og="og"
              :reload="reload"
              @updateCb="updateCb"
              @removeCb="removeCb"
              @applyFilter="apply"
            ></component>
          </v-expansion-panel-content>
          <v-divider></v-divider>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <v-bottom-navigation absolute grow color="primary" class="btm-nav shadow">
      <SaveFilter
        @save="saveFilter"
        :custom="custom"
        :name="name"
        :description="description"
      ></SaveFilter>
      <v-btn text :disabled="!showClearAll" @click="reset()">
        Reset
        <v-icon>mdi-reload</v-icon>
      </v-btn>
      <AddFilter
        :selected-filters="selectedFilters"
        @toggleFilter="toggleFilter"
      ></AddFilter>
      <v-btn class="d-flex d-sm-none" text @click="closeFilter()">
        Close
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </v-card>
</template>

<style>
.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 48px;
}

.v-expansion-panel-content__wrap {
  padding: 0px 8px !important;
}

.s-filter-ogs {
  /* 
    50px(top bar) 
      - 0px (container padding)
      - 70px (Filter header) 
      - 56px (Add Filter button)
  */
  height: calc(100vh - 50px - 70px - 56px - 5px);
  overflow: auto;
}

.screener .filter {
  border-right: 1px solid rgba(0, 0, 0, 0.15) !important;
}

.btm-nav .v-btn {
  font-weight: 600 !important;
}
</style>

<script>
import AddFilter from "@/components/filter/AddFilter";
import Checkbox from "@/components/filter/CheckBox";
import Slider from "@/components/filter/Slider";
import SaveFilter from "@/components/filter/SaveFilter";
import StockUniverse from "@/components/filter/StockUniverse";
export default {
  name: "OptionGroups",
  components: { AddFilter, Checkbox, Slider, SaveFilter, StockUniverse },
  props: {
    name: { type: String, required: true },
    description: { type: String },
    ogs: { type: Array, required: true },
    selectedFilters: { type: Array, required: true },
    custom: { type: Boolean, required: true },
    reload: { type: Boolean },
  },
  data: () => ({
    selectedCodes: [],
    openStockUniverse: false,
  }),
  methods: {
    resetAll() {
      this.$emit("reset", true);
    },
    apply({ id, action, val, cbId}) {
      this.$emit("applyFilter", { id, action, val, cbId });
    },
    reset() {
      this.apply({ action: "reset" });
    },
    selectAll(og) {
      switch (og.optionType) {
        case "Checkbox":
          var l = og.checkboxes.filter(cb => cb.count>0 && !cb.selected);
          if (l == 0) {
            return;
          }
          og.checkboxes.forEach((cb) => {
            if (cb.count > 0) {
              cb.selected = true;
            }
          });
          break;
          default: return;
      }
      og.showClearOption = false;
      this.apply({ id: og.refId, action: "clear_og" });
    },
    clear(og) {
      switch (og.optionType) {
        case "Checkbox":
          og.checkboxes.forEach((cb) => {
            cb.selected = false;
          });
          break;
        case "Slider":
          og.slider.selected = false;
          og.slider.selectedMin = og.slider.options.floor;
          og.slider.selectedMax = og.slider.options.ceil;
          break;
      }
      og.showClearOption = false;
      this.apply({ id: og.refId, action: "clear_og" });
    },
    toggleFilter({ id, action, lock }) {
      this.$emit("toggleFilter", { id, action, lock });
    },
    closeFilter() {
      this.$emit("closeFilter", true);
    },
    saveFilter({ name, description }) {
      this.$emit("save", { name, description });
    },
    appendOgs({ ogId, name, refId, codes, preSelect, ordinal }) {
      this.ogs.some((og) => {
        if (og.refId != ogId) {
          return false;
        }
        if (!og.checkboxes) og.checkboxes = [];
        let idx = -1;
        og.checkboxes.some((cb, i) => {
          if (cb.refId === refId) {
            idx =i
            return true
          }
        })
        if (idx > -1) {
          og.checkboxes.splice(idx, 1);
        }
        og.checkboxes.push({
          count: 0,
          disabled: false,
          hide: false,
          name,
          ordinal,
          refId,
          selected: preSelect,
          valType: 3,
          value: codes,
        });
        return true;
      });
      this.apply({ id: ogId });
    },
    updateCb({ cb }) {
      this.selectedCodes = cb;
    },
    removeCb({ og, cbId }) {
      switch (og.optionType) {
        case "Checkbox":
          og.checkboxes.forEach((cb, idx) => {
            if (cb.refId == cbId) {
              og.checkboxes.splice(idx, 1);
            }
          });
          break;
      }
      this.apply({ id: og.refId });
    },
  },
  computed: {
    showClearAll() {
      return !!this.ogs.filter((og) => og.showClearOption).length;
    },
  },
};
</script>